const RETURN_TO_HOME_TEXT = 'Return to Home Page';
const DEFAULT_VERIFICATION_ISSUE_MESSAGE = 'Oops, We hit a snag with your verification';
const SUPPORT_HOURS_NOTE = 'Ticket support will review submissions Monday–Friday:\nUSA 8:30 AM – 3:00 PM PST\nIndia – 9:00 PM – 3:30 AM IST\nPhilippines – 11:30 PM – 6:00 AM PHT\n\nInstructions for next steps will be delivered via email within 1–2 business days within those hours.';
const VERIFICATION_DESCRIPTION = 'We weren\'t able to verify your identity — but no worries, this happens from time to time! Give it another try by clicking Return to Home Page. If things still aren\'t working, our support team would love to help — just hit File a Support Ticket and we\'ll get back to you.';
const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL;
const SOMETHING_WENT_WRONG_MESSAGE = (
  <>
    We're having trouble on our end. Please try again in a few moments — if the issue persists, contact{' '}
    <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
      {SUPPORT_EMAIL}
    </a>
    {' '}for further assistance.
  </>
);


export default {
  unauthorized: {
    heading: 'Unauthorized Access',
    description: 'You do not have permission to access this page.',
    primaryButtonText: RETURN_TO_HOME_TEXT,
  },
  "bad-request": {
    heading: DEFAULT_VERIFICATION_ISSUE_MESSAGE,
    description: VERIFICATION_DESCRIPTION,
    supportHours: SUPPORT_HOURS_NOTE,
    primaryButtonText: RETURN_TO_HOME_TEXT,
  },
  pageNotFound: {
    heading: '404 Page not found',
    description: 'The page you are looking for does not exist.',
  },
  verificationError: {
    heading: DEFAULT_VERIFICATION_ISSUE_MESSAGE,
    description: VERIFICATION_DESCRIPTION,
    supportHours: SUPPORT_HOURS_NOTE,
    primaryButtonText: RETURN_TO_HOME_TEXT,
  },
  'pageNotFound-Forbidden': {
    heading: 'Unauthorized access',
    description: 'You do not have access to this resource.',
    primaryButtonText: RETURN_TO_HOME_TEXT,
    secondaryButtonText: RETURN_TO_HOME_TEXT,
  },
  serverError: {
    heading: 'Something Went Wrong',
    description: SOMETHING_WENT_WRONG_MESSAGE,
    primaryButtonText: RETURN_TO_HOME_TEXT,
    secondaryButtonText: RETURN_TO_HOME_TEXT,
  },
  unknownError: {
    heading: 'Something Went Wrong',
    description: SOMETHING_WENT_WRONG_MESSAGE,
    primaryButtonText: RETURN_TO_HOME_TEXT,
  },
  sessionNotFound: {
    heading: 'Looks like your session timed out',
    description: 'No worries — it happens! Just head back to the home page and give it another go.',
    primaryButtonText: RETURN_TO_HOME_TEXT,
  },
};
